// extracted by mini-css-extract-plugin
module.exports = {"expandible":"Expandible_expandible__2LUKu","button":"Expandible_button__26l_S"};